// extracted by mini-css-extract-plugin
module.exports = {"container":"_320f7a67","textHeader":"_9ceaa51c","main":"b9a4b1a9","content":"b404b6ff bg-white br3 bg-white br3"};